import React from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Modal,
  Tooltip,
  Typography
} from '@material-ui/core';
import { Card, CardFooter } from 'reactstrap';
import VisibilityIcon from '@material-ui/icons/Visibility';
import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import DescriptionIcon from '@material-ui/icons/Description';
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined';
import CloseIcon from '@material-ui/icons/Close';
import FileSaver from 'file-saver';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import FileViewer from 'react-file-viewer';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import { ScaleLoader } from 'react-spinners';
import { isNullOrUndefined } from 'util';
import { ProviderContext, withSnackbar } from 'notistack';
import { AppContext, ApplicationContext } from '../../context/Contexts';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { ICaseService } from '../../services/Interfaces/ICaseService';
import { IReportsService } from '../../services/Interfaces/IReportsService';
import {
  CaseAttachment,
  CaseSelectedAttachment,
  GetCaseAttachmentsArchiveRequestDto
} from '../../interfaces/Case';
import { IReferential } from '../../interfaces/IReferential';
import { AttachmentTypeCode, UploadSizeLimit } from '../../helpers/Constants';
import _ from 'lodash';
import renewLogo from '../../assets/images/renew.png';
import RepairServiceInvoiceView from './RepairServiceInvoiceView';

export const imageExtensions = ['png', 'jpeg', 'jpg', 'bmp'];

export interface ExternalCaseAttachmentCardProps {
  caseId: number;
  attachmentType: IReferential | null;
  attachments: CaseAttachment[];
  hasRights: boolean;
  isMultiple: boolean;
  isSelectionGroup: boolean;
  allowOnlyImages: boolean;
  addWatermark: boolean;
  showUploadMessage: boolean;
  downloadModelFile: boolean;
  viewHiddenServiceDocuments: boolean;
  organizationName: string;
  organizationCity: string;
  onAttachmentsChanged: (attachments: CaseAttachment[]) => void;
  onAddInvoice?: () => void;
  headerAction: React.ReactNode | null;
  isDamagePhoto: boolean;
}

type CaseAttachmentCardProps = ExternalCaseAttachmentCardProps & ProviderContext;

interface CaseAttachmentCardState {
  isLoading: boolean;
  isDialogOpen: boolean;
  previewAttachFile: any;
  previewAttachFileExtension: string;
  isCameraDialogOpen: boolean;
  isOpen: boolean;
  dialogVisible: boolean;
  selectedAttachment: CaseSelectedAttachment;
  fileInputKey: number;
  isImageLoading: boolean;
}

class CaseAttachmentCard extends React.PureComponent<
  CaseAttachmentCardProps,
  CaseAttachmentCardState
> {
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private reportsService!: IReportsService;
  static contextType = ApplicationContext;

  state = {
    isLoading: false,
    isDialogOpen: false,
    previewAttachFile: '',
    previewAttachFileExtension: '',
    isCameraDialogOpen: false,
    isOpen: false,
    dialogVisible: false,
    selectedAttachment: { id: -1, fileName: '' },
    fileInputKey: 0,
    isImageLoading: true
  } as CaseAttachmentCardState;

  private isInvoiceType = (): boolean => {
    return (
      this.props.attachmentType?.code ===
      AttachmentTypeCode.REPAIR_SERVICE_INVOICE_TO_GTM.toString()
    );
  };

  private canUpload = (): boolean => {
    if (!this.props.isMultiple && this.props.attachments.length >= 1) {
      return false;
    }
    return true;
  };

  modifySelectionImage = async (file: File, dealerName: string, city: string): Promise<File> => {
    console.log('Dealer Name: ', dealerName, 'City: ', city);
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = () => {
          const scaledWidth = 800;
          const blackBarHeight = 75;
          const scaleFactor = scaledWidth / img.width;
          const scaledHeight = img.height * scaleFactor;

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) return reject('Context nul');

          canvas.width = scaledWidth;
          canvas.height = scaledHeight + blackBarHeight * 2;

          // Fundal negru sus
          ctx.fillStyle = 'black';
          ctx.fillRect(0, 0, scaledWidth, blackBarHeight);

          // Imagine în centru
          ctx.drawImage(img, 0, blackBarHeight, scaledWidth, scaledHeight);

          // Fundal negru jos
          ctx.fillStyle = 'black';
          ctx.fillRect(0, scaledHeight + blackBarHeight, scaledWidth, blackBarHeight);

          const logo = new Image();
          logo.src = renewLogo;

          logo.onload = () => {
            const logoWidth = logo.width;
            const logoHeight = logo.height;
            const logoX = 25;
            const logoY = (blackBarHeight - logoHeight) / 2;

            // Logo
            ctx.drawImage(logo, logoX, logoY, logoWidth, logoHeight);

            // Text lângă logo
            ctx.fillStyle = 'white';
            ctx.font = '22px NouvelR, sans-serif';
            const textLines = [
              'vehicule de ocazie verificate, realiniate si certificate',
              'electrice, hybride, diesel, benzina si GPL'
            ];
            const textX = logoX + logoWidth + 17;
            const textY = logoY + 17;
            textLines.forEach((line, index) => {
              ctx.fillText(line, textX, textY + index * 25);
            });

            // Textul dealerului (jos dreapta)
            ctx.fillStyle = 'white';
            ctx.font = '700 36px NouvelR, sans-serif';
            ctx.textAlign = 'right';
            ctx.textBaseline = 'middle';
            const dealerX = scaledWidth - 25;
            const dealerY = scaledHeight + blackBarHeight + blackBarHeight / 2 - (city ? 10 : 0);
            ctx.fillText(dealerName, dealerX, dealerY);

            if (city) {
              ctx.font = '500 18px NouvelR, sans-serif';
              ctx.fillText(city, dealerX, dealerY + 25);
            }

            // Convertim în fișier final
            const outputType = file.type === 'image/jpeg' ? 'image/jpeg' : 'image/png';
            const outputQuality = outputType === 'image/jpeg' ? 0.8 : 1.0;

            canvas.toBlob(
              (blob) => {
                if (!blob) return reject('Eroare la blob');
                const ext = outputType === 'image/jpeg' ? '.jpg' : '.png';
                const newFile = new File([blob], file.name.replace(/\.\w+$/, ext), {
                  type: outputType
                });
                resolve(newFile);
              },
              outputType,
              outputQuality
            );
          };

          logo.onerror = (err) => {
            console.error('Eroare la încărcarea logo-ului', err);
            reject(err);
          };
        };

        img.onerror = (err) => {
          console.error('Eroare la încărcarea imaginii', err);
          reject(err);
        };
      };

      reader.onerror = (err) => {
        console.error('Eroare la citirea fișierului', err);
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };

  modifyImage = async (file: File): Promise<File> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = () => {
          const scaledWidth = 800;
          const scaleFactor = scaledWidth / img.width;
          const scaledHeight = img.height * scaleFactor;

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) return;

          canvas.width = scaledWidth;
          canvas.height = scaledHeight;

          // Desenăm imaginea redimensionată
          ctx.drawImage(img, 0, 0, scaledWidth, scaledHeight);

          // Generare fișier final
          const outputType = file.type === 'image/jpeg' ? 'image/jpeg' : 'image/png';
          const outputQuality = outputType === 'image/jpeg' ? 0.8 : 1.0;

          canvas.toBlob(
            (blob) => {
              const ext = outputType === 'image/jpeg' ? '.jpg' : '.png';
              const newFile = new File([blob!], file.name.replace(/\.\w+$/, ext), {
                type: outputType
              });
              resolve(newFile);
            },
            outputType,
            outputQuality
          );
        };

        img.onerror = (err) => {
          console.error('Eroare la încărcarea imaginii', err);
          reject(err);
        };
      };

      reader.onerror = (err) => {
        console.error('Eroare la citirea fișierului', err);
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };

  handleUploadAttachment = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      if (e.target.files === null) {
        return;
      }
      e.persist();
      if (this.props.showUploadMessage) {
        if (e.target.files.length > 80 && this.props.isMultiple) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate('MORE_PHOTOS', 'Limita de 80 de poze a fost depasita!'),
            {
              variant: 'warning'
            }
          );
          e.target.value = '';
          return;
        }
      }
      this.setState({ isLoading: true });

      const unacceptedFileList: string[] = [];
      const attachments: CaseAttachment[] = [];
      const unacceptedCertificateFileList: string[] = [];
      for (let i = 0; i < e.target.files.length; i++) {
        let file = e.target.files![i];
        const ext = file.name.toLowerCase().split('.').pop();

        if (this.props.allowOnlyImages) {
          if (!ext || !imageExtensions.includes(ext)) {
            unacceptedFileList.push(file.name);
            continue;
          }
        }

        //pentru selection grup
        if (this.props.isSelectionGroup) {
          if (
            this.props.attachmentType?.code ==
            AttachmentTypeCode.CERTIFICAT_CALITATE_SI_ORIGINE.toString()
          ) {
            if (ext !== 'pdf') {
              unacceptedCertificateFileList.push(file.name);
              continue;
            }
          } else {
            if (ext && imageExtensions.includes(ext)) {
              if (this.props.addWatermark) {
                const newSelectionImage = await this.modifySelectionImage(
                  file,
                  this.props.organizationName.toUpperCase(),
                  this.props.organizationCity
                );
                file = newSelectionImage;
              } else {
                file = await this.modifyImage(file);
              }
            } else {
              if (!this.props.allowOnlyImages) {
                unacceptedFileList.push(file.name);
                continue;
              }
            }
          }
        }

        attachments.push({
          id: 0,
          caseId: this.props.caseId,
          attachmentTypeId: this.props.attachmentType?.id,
          attachmentType: this.props.attachmentType,
          file: file,
          isSelection: this.props.isSelectionGroup
        } as CaseAttachment);
      }

      if (unacceptedFileList.length) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'RENAULT_ACCEPTED_FORMAT',
            'Tipul fisierului acceptat este png, jpeg, jpg, bmp!'
          ) +
            ' \n' +
            this.translatorService.Tranlate(
              'RENAULT_ACCEPTED_FORMAT_MESSAGE',
              'Urmatoarele fisiere nu indeplinesc acesta conditie: '
            ) +
            ' \n' +
            unacceptedFileList.join(', '),
          {
            variant: 'warning',
            style: { whiteSpace: 'pre-line' }
          }
        );
        e.target.value = '';
        this.setState({ isLoading: false });
        return;
      }

      if (unacceptedCertificateFileList.length) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'RENAULT_CERTIFICATE_VALIDATION_MESSAGE',
            'Tipul fisierului acceptat este PDF!'
          ) +
            ' \n' +
            this.translatorService.Tranlate(
              'RENAULT_ACCEPTED_FORMAT_MESSAGE',
              'Urmatoarele fisiere nu indeplinesc acesta conditie: '
            ) +
            ' \n' +
            unacceptedCertificateFileList.join(', '),
          {
            variant: 'warning',
            style: { whiteSpace: 'pre-line' }
          }
        );
        e.target.value = '';
        this.setState({ isLoading: false });
        return;
      }

      const size = _.sumBy(attachments, 'file.size');
      if (this.props.showUploadMessage) {
        if (size > UploadSizeLimit.SizeLimit) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate('MAX_SIZE_PHOTOS', 'Limita de 500 MB a fost depasita!'),
            {
              variant: 'warning'
            }
          );
          e.target.value = '';
          this.setState({ isLoading: false });
          return;
        }
      }

      const newFiles = await this.caseService.AddCaseAttachment(attachments);
      newFiles.forEach((item, index) => {
        item.file = attachments[index].file;
      });
      this.props.onAttachmentsChanged([...this.props.attachments, ...newFiles]);

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
      e.target.value = '';
      this.setState({ isLoading: false });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
      e.target.value = '';
      this.setState({ isLoading: false });
    }
  };

  handleUploadAttachmentFromCamera = async (files: File[]) => {
    try {
      if (files === null) {
        return;
      }
      if (this.props.showUploadMessage) {
        if (files.length > 80) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate('MORE_PHOTOS', 'Limita de 80 de poze a fost depasita!'),
            {
              variant: 'warning'
            }
          );
          return;
        }
      }

      const attachments: CaseAttachment[] = [];
      for (let i = 0; i < files.length; i++) {
        attachments.push({
          id: 0,
          caseId: this.props.caseId,
          attachmentTypeId: this.props.attachmentType?.id,
          attachmentType: this.props.attachmentType,
          file: files![i],
          isSelection: this.props.isSelectionGroup
        } as CaseAttachment);
      }

      if (this.props.showUploadMessage) {
        const size = _.sumBy(attachments, 'file.size');
        if (size > UploadSizeLimit.SizeLimit) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate('MAX_SIZE_PHOTOS', 'Limita de 500 MB a fost depasita!'),
            {
              variant: 'warning'
            }
          );
          return;
        }
      }

      const newFiles = await this.caseService.AddCaseAttachment(attachments);
      newFiles.forEach((item, index) => {
        item.file = attachments[index].file;
      });
      this.props.onAttachmentsChanged([...this.props.attachments, ...newFiles]);

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  setCameraDetails = () => {
    this.setState({ isCameraDialogOpen: true });
  };

  closeCameraDialog = () => {
    this.setState({ isCameraDialogOpen: false });
  };

  handleTakePhoto = async (dataUri: any) => {
    const arr = dataUri.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    let i = n;
    while (i--) {
      u8arr[i] = bstr.charCodeAt(i);
    }

    const files = [
      new File([u8arr], 'captured_image_' + Math.random().toString(36).slice(2) + '.png', {
        type: mime
      })
    ];
    this.handleUploadAttachmentFromCamera(files);
  };

  openDeleteAttachmentPopUp = (id: number, fileName: string) => {
    this.setState({
      isOpen: true,
      dialogVisible: true,
      selectedAttachment: { id: id, fileName: fileName }
    });
  };

  handleCloseConfirmationDialog = () => {
    this.setState({ isOpen: false, dialogVisible: false });
  };

  handleDeleteAttachment = async (fileName: string) => {
    try {
      this.setState({ isOpen: false, dialogVisible: false });
      await this.caseService.RemoveCaseAttachment(fileName);

      const attachments = this.props.attachments.filter((item) => item.fileName !== fileName);
      this.props.onAttachmentsChanged(attachments);

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
      this.setState({ fileInputKey: Date.now() });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handlePreviewAttachment = async (originalFileName: string, fileName: string) => {
    try {
      const fileBlob = await this.caseService.GetCaseAttachment(fileName);
      const url = URL.createObjectURL(fileBlob);
      const extension = originalFileName.split('.').pop();
      if (isNullOrUndefined(extension)) {
        return;
      }
      this.setState({
        previewAttachFile: url,
        previewAttachFileExtension: extension!.toLowerCase(),
        isDialogOpen: true
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  downloadFile = async (fileName: string, originalFileName: string) => {
    const fileBlob = await this.caseService.GetCaseAttachment(fileName);
    FileSaver.saveAs(fileBlob, originalFileName);
  };

  downloadAll = async () => {
    try {
      this.setState({ isLoading: true });
      const fileBlob = await this.caseService.GetCaseAttachmentsArchive({
        caseId: this.props.caseId,
        types: [this.props.attachmentType!.code!],
        formId: null,
        viewHiddenServiceDocuments: this.props.viewHiddenServiceDocuments
      } as GetCaseAttachmentsArchiveRequestDto);
      this.setState({ isLoading: false });
      FileSaver.saveAs(
        fileBlob,
        this.props.caseId + '_' + (this.props.attachmentType?.displayName ?? '') + '.zip'
      );
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
      this.setState({ isLoading: false });
    }
  };

  downloadModel = async () => {
    try {
      this.setState({ isLoading: true });
      const fileBlob = await this.reportsService.GetReport(this.props.attachmentType!.code!, []);
      this.setState({ isLoading: false });
      FileSaver.saveAs(fileBlob, (this.props.attachmentType?.displayName ?? '') + '.pdf');
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
      this.setState({ isLoading: false });
    }
  };

  closeDialog = () => {
    this.setState({ isDialogOpen: false });
  };

  private renderHeader = () => {
    const { attachmentType, attachments, isMultiple, isSelectionGroup, downloadModelFile } =
      this.props;
    return (
      <div className="card-header">
        <div className="card-header--title">
          <b>{isSelectionGroup ? 'Renew: ' : ''}</b>
          <b>
            {attachmentType?.displayName}
            {isMultiple ? (
              <IconButton
                aria-label="download"
                color="inherit"
                size="small"
                disabled={attachments.length === 0}
                onClick={this.downloadAll}
              >
                <GetAppIcon />
              </IconButton>
            ) : (
              ''
            )}
          </b>
          {downloadModelFile && (
            <b>
              {this.translatorService.Tranlate('DOWNLOAD_MODEL_FILE', 'Descarca model')}
              <IconButton
                aria-label="download"
                color="inherit"
                size="small"
                onClick={this.downloadModel}
              >
                <GetAppIcon />
              </IconButton>
            </b>
          )}
        </div>
        {this.props.headerAction && (
          <div className="card-header--actions">{this.props.headerAction}</div>
        )}
      </div>
    );
  };

  private onImageLoaded = () => {
    this.setState({ isImageLoading: false });
  };

  private renderPreviewImage = (attach: CaseAttachment) => {
    const url = attach.file ? URL.createObjectURL(attach.file) : attach.url;
    if (!this.props.isDamagePhoto || !url) {
      return <img src={url} alt={attach.fileName} className="img-fluid" />;
    }

    return (
      <div className="d-flex justify-content-center w-100">
        {this.state.isImageLoading && <CircularProgress size={24} />}
        <img
          src={url}
          alt={attach.fileName}
          className="img-fluid"
          style={{ display: this.state.isImageLoading ? 'none' : undefined }}
          onLoad={this.onImageLoaded}
          onError={this.onImageLoaded}
        />
      </div>
    );
  };

  private renderAttachmentRow = (attach: CaseAttachment, index: number) => {
    return (
      <React.Fragment key={index}>
        <Grid container spacing={0}>
          <Grid item xs={1}>
            <div className="d-flex align-items-center">
              <IconButton
                aria-label="preview"
                color="inherit"
                className="text-primary"
                size="small"
                onClick={() =>
                  this.handlePreviewAttachment(attach.originalFileName, attach.fileName)
                }
              >
                <VisibilityIcon />
              </IconButton>
            </div>
          </Grid>
          <Grid item xs={9}>
            <div className="align-box-row text-wrap " style={{ wordBreak: 'break-all' }}>
              <small>
                <Button
                  color="primary"
                  className="m-2 text-primary"
                  onClick={() => this.downloadFile(attach.fileName, attach.originalFileName)}
                >
                  <span>{attach.originalFileName}</span>
                </Button>{' '}
              </small>
            </div>
          </Grid>
          <Grid item xs={2}>
            <div className="d-flex align-items-center">
              <IconButton
                aria-label="download"
                color="inherit"
                size="small"
                onClick={() => this.downloadFile(attach.fileName, attach.originalFileName)}
              >
                <GetAppIcon />
              </IconButton>
              <IconButton
                aria-label="delete"
                color="inherit"
                hidden={!this.props.hasRights}
                className="text-danger"
                size="small"
                onClick={() => this.openDeleteAttachmentPopUp(attach.id, attach.fileName)}
              >
                <DeleteOutlineTwoToneIcon />
              </IconButton>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={0}>
          <Grid item xs={12}>
            {this.props.isMultiple === false &&
            (this.props.isSelectionGroup || this.props.isDamagePhoto) ? (
              <div style={{ flexBasis: '100%' }}>
                <div className="d-flex align-items-center w-100 h-100">
                  {this.props.attachmentType?.code ==
                  AttachmentTypeCode.CERTIFICAT_CALITATE_SI_ORIGINE.toString()
                    ? ''
                    : this.renderPreviewImage(attach)}
                </div>
              </div>
            ) : (
              ''
            )}
          </Grid>
        </Grid>

        {this.isInvoiceType() && attach.invoice ? (
          <div style={{ whiteSpace: 'normal' }}>
            <Grid container spacing={0}>
              <RepairServiceInvoiceView invoice={attach.invoice} />
            </Grid>
          </div>
        ) : null}
      </React.Fragment>
    );
  };

  private renderFooter = () => {
    const disabled = !this.props.hasRights || !this.canUpload();

    if (this.isInvoiceType()) {
      return (
        <ButtonGroup className="w-100">
          <Button
            variant="contained"
            color="secondary"
            className="d-block w-100 text-center shadow-none"
            disabled={disabled}
            onClick={this.props.onAddInvoice}
          >
            {this.translatorService.Tranlate('REPAIR_SERVICE_INVOICE_ADD_BTN', 'Adauga factura')}
          </Button>
        </ButtonGroup>
      );
    }

    const inputId = 'case-attachment-file-' + (this.props.attachmentType?.id ?? 0);
    return (
      <ButtonGroup className="w-100">
        <Button
          style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
          variant="contained"
          color="primary"
          className="d-block w-100 text-center shadow-none"
          disabled={disabled}
        >
          <input
            className="d-none"
            key={this.state.fileInputKey}
            id={inputId}
            disabled={disabled}
            onChange={this.handleUploadAttachment}
            type="file"
            multiple={!!this.props.isMultiple}
          />
          <label htmlFor={inputId} className="w-100 mb-0">
            {this.translatorService.Tranlate('CASE_TAB_DOCUMENTS_FORM_UPLOAD', 'Upload')}
          </label>
        </Button>
        <Tooltip
          title={
            !this.props.hasRights
              ? ''
              : this.translatorService.Tranlate('CASE_DATA_TAKE_PHOTO_TITLE', 'Fotografiaza')
          }
        >
          <IconButton
            component="div"
            disabled={
              disabled ||
              this.props.attachmentType?.code ==
                AttachmentTypeCode.CERTIFICAT_CALITATE_SI_ORIGINE.toString()
            }
            style={{
              border: '2px solid var(--primary)',
              borderTopRightRadius: '8px',
              borderBottomRightRadius: '8px'
            }}
            onClick={this.setCameraDetails}
            aria-label="photo"
            color="primary"
            size="medium"
            className="p-0"
          >
            <PhotoCameraOutlinedIcon />
          </IconButton>
        </Tooltip>
      </ButtonGroup>
    );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.reportsService = (this.context as AppContext).reportsService;

    const { attachments } = this.props;

    return (
      <>
        <Card className="card-box w-100 shadow-none">
          {this.renderHeader()}
          <CardContent className="p-3 flex-grow-1">
            <div className="d-flex flex-row text-center flex-wrap justify-content-center">
              <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
            </div>
            {!this.state.isLoading ? (
              <div className="file-manager-wrapper h-100">
                {attachments.length !== 0 ? (
                  <div className="table-responsive">
                    <table className="table table-striped table-hover text-nowrap mb-0">
                      <tbody>
                        <tr>
                          <td>
                            {attachments.map((attach, index) =>
                              this.renderAttachmentRow(attach, index)
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="h-100 align-self-center text-center">
                    <DescriptionIcon className="h-100" color="primary" fontSize="large" />
                  </div>
                )}
              </div>
            ) : null}
          </CardContent>
          <CardFooter className="p-3 border-0">{this.renderFooter()}</CardFooter>
        </Card>

        <Dialog
          onClose={this.closeDialog}
          aria-labelledby="case-attachment-preview-title"
          open={this.state.isDialogOpen}
          maxWidth="md"
          fullWidth
          classes={{ paper: 'dialogPaper' }}
          scroll="body"
        >
          <DialogTitle id="case-attachment-preview-title">
            <Grid container>
              <Grid item xs={11}>
                <Typography variant="h4">
                  {this.translatorService.Tranlate('CASE_PREVIEW_DOC', 'Previzualizare document')}
                </Typography>
              </Grid>
              <Grid className="text-right" item xs={1}>
                <IconButton aria-label="close" onClick={this.closeDialog} size="small">
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container alignContent="center">
              <Grid item xs={12}>
                <Box height="65vh" className="text-center">
                  <FileViewer
                    fileType={this.state.previewAttachFileExtension}
                    filePath={this.state.previewAttachFile}
                  />
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={this.closeCameraDialog}
          aria-labelledby="case-attachment-camera-title"
          open={this.state.isCameraDialogOpen}
          fullWidth
          maxWidth={'lg'}
        >
          <DialogTitle id="case-attachment-camera-title">
            <Grid container>
              <Grid item xs={11}>
                <Typography variant="h4">
                  {this.translatorService.Tranlate('CASE_DATA_TAKE_PHOTO_TITLE', 'Fotografiaza')}
                </Typography>
              </Grid>
              <Grid className="text-right" item xs={1}>
                <IconButton aria-label="close" onClick={this.closeCameraDialog} size="small">
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent dividers>
            <Camera
              onTakePhoto={(dataUri: any) => {
                this.handleTakePhoto(dataUri);
              }}
              onTakePhotoAnimationDone={() => {
                this.closeCameraDialog();
              }}
              mirrored={true}
            />
          </DialogContent>
        </Dialog>

        <Modal open={this.state.isOpen} onClose={this.handleCloseConfirmationDialog}>
          <Dialog open={this.state.dialogVisible} onClose={this.handleCloseConfirmationDialog}>
            <DialogContent>
              <DialogContentText style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                {`${this.translatorService.Tranlate(
                  'DOCUMENT_DELETE_CONFIRMATION_MESSAGE',
                  'Sunteti sigur ca doriti sa stergeti documentul?'
                )} `}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                onClick={() => this.handleDeleteAttachment(this.state.selectedAttachment.fileName)}
              >
                {this.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_YES', 'Da')}
              </Button>
              <Button onClick={this.handleCloseConfirmationDialog}>
                {this.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_NO', 'Nu')}
              </Button>
            </DialogActions>
          </Dialog>
        </Modal>
      </>
    );
  }
}

export default withSnackbar(CaseAttachmentCard as any) as unknown as (
  props: ExternalCaseAttachmentCardProps
) => JSX.Element;
